import { ChangeEvent, FormEvent, useContext, useState } from "react";
import {  Modal, ModalBody, ModalHeader } from "reactstrap";
import Button from "../Forms/Button";
import styles from "./SaveNewSegmentModal.module.css";
import { SegmentContext } from "./SegmentContext";
import { ISegment } from "./SegmentTypes";
import { MisterIcon } from "@rtel/mister-icons";



export default function SaveNewSegmnetModal() {
  const currentFilterContext = useContext(SegmentContext);
  const [inputdata, setInputData] = useState("");
  
  const handleSubmit = (event: FormEvent<HTMLFormElement>) =>{
    event.preventDefault();
    console.log("submitInput", inputdata);
    let newSegment :ISegment = {name: inputdata}
    currentFilterContext.addSegment(newSegment);
    
  };

  const handleInput = (e: ChangeEvent<HTMLInputElement>) => {
    setInputData(e.target.value);
  }

  const handleDelete = () =>{
    currentFilterContext.segmentList.splice(-1)
    console.log("segmentList after delete" ,currentFilterContext.segmentList)
  }

  return (
    <Modal isOpen={currentFilterContext.isModalVisible}>
      
      <ModalHeader className={styles.header}>
        <span className={styles.modaltitle}>Save Segment</span>
        <button className={styles.closebutton} onClick={() => currentFilterContext.toggleModalVisibility()}>
          <MisterIcon name="XClose" size="lg" />
        </button>
      </ModalHeader>
      <ModalBody>
        <form onSubmit={handleSubmit}>
          <label className={styles.label}>{"Segment Name"}</label>
          <input
            name="Segment Name"
            className={`form-control ${styles.field}`}
            placeholder=""
            type="text"
            onChange={handleInput}
          />
          
          <Button type="submit" size="lg" styletype="primary">
            {"Save Segment"}
          </Button>
          <Button onClick={handleDelete} size="lg" styletype="secondary">
            {"Delete Segment"}
          </Button>
          <button onClick={() => currentFilterContext.toggleModalVisibility()} className={styles.cancelbutton}>Cancel</button>
        </form>
      </ModalBody>
    </Modal>
  );
}


